// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"60957":"7d3ae8e70bf8886c","74724":"b6323009d4472833","96325":"93b80ed7115e129f"}[chunkId] + ".css";
};